import { render } from "./chatView.vue?vue&type=template&id=0f406dd6"
import script from "./chatView.vue?vue&type=script&lang=js"
export * from "./chatView.vue?vue&type=script&lang=js"

import "./chatView.vue?vue&type=style&index=0&id=0f406dd6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__